export default "/images/layout-two-columns.svg?744490cb2f6963674b9bad2e2787201c";